import React from 'react';
import scrollIntoView from 'scroll-into-view';
import FilterContainer from './container';
import CurrentFilters from './currentFilters';
import FilterItem from './item';
import SortIcon from 'images/sort-icon.png';

const SORT_OPTIONS = [
  { label: 'Relevance', queryParams: { sort: null, order: null, skip: null } },
  { label: 'A to Z', queryParams: { sort: 'title', order: null, skip: null } },
  {
    label: 'Price: Low to High',
    queryParams: { sort: 'price', order: null, skip: null }
  },
  {
    label: 'Price: High to Low',
    queryParams: { sort: 'price', order: 'desc', skip: null }
  }
];

function facetOptions(facet, values = {}) {
  return Object.keys(values).map(label => {
    return {
      facet,
      label,
      count: values[label],
      queryParams: {
        [facet]: label,
        skip: null
      }
    };
  });
}

function checkInView({ current }) {
  if (current) {
    scrollIntoView(current, {
      time: 300,
      align: { top: 0, topOffset: 300 }
    });
  }
}

const containerRef = React.createRef();

export default function SearchFilters({ location, facets }) {
  return (
    <FilterContainer ref={containerRef}>
      <CurrentFilters facets={facets} location={location} />

      <FilterItem
        title="Sort"
        icon={SortIcon}
        options={SORT_OPTIONS}
        location={location}
        onSelect={() => checkInView(containerRef)}
      />

      {facets.map(({ facet, display_name, icon, values }) => (
        <FilterItem
          key={facet}
          title={display_name}
          icon={icon}
          options={facetOptions(facet, values)}
          location={location}
          onSelect={() => checkInView(containerRef)}
        />
      ))}
    </FilterContainer>
  );
}
